import React, { useEffect, useState } from 'react';
import './Hero.css';

function HeroEn() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero" id="hero">
      <div 
        className="hero-background"
        style={{ 
          transform: `translateY(${scrollY * 0.5}px)`
        }}
      >
        {/* Native video element for instant playback, no external dependencies */}
        {/* Poster shows first frame for seamless transition to video */}
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={`${process.env.PUBLIC_URL}/frame1.jpg`}
        >
          <source src={`${process.env.PUBLIC_URL}/VIDEO PORTADA.mp4`} type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="hero-title-main">TABIA is a diversified<br />asset management<br />and business group</span>
        </h1>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
}

export default HeroEn;
